import React from "react";
import { graphql, Link } from "gatsby";
import styled from 'styled-components';

import {AnotherLayout} from "../components/Layout";
import Seo from "../components/seo";

import { rhythm } from "../utils/typography";
import EmojiWrapper from "../components/EmojiWrapper";




const BlogsDiv = styled.div`
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  margin-bottom: 1rem;
`;

const Blog = styled.div`
  width:48%;
  border-radius:30px;
  height:fit-content;
  background:var(--color-background);
  border:1px solid var(--color-gray3);
  transition:box-shadow .15s ease;
  margin:${rhythm(0.5)} 0;
  h1{
    font-size:1.5rem;
    margin:0;
  }
  @media only screen and (max-width: 768px) {
    width:100%;
  }
  :hover{
    border-color:var(--color-gray1);
    box-shadow:0px 30px 60px 0px rgba(0, 0, 0, 0.12);
  }
`;


const PaginationDiv = styled.div`
  text-align:center;
  margin-top:${rhythm(1)};
  margin-bottom: ${rhythm(4)};
`;

const PaginationItems = styled.div`
  display:inline;
  padding:${rhythm(0.2)} ${rhythm(0.4)};
  background: ${({ currentPage }) => currentPage ? 'var(--color-secondary)' : 'var(--color-gray3)'};
  color: ${({ currentPage }) => currentPage ? 'var(--color-headingFont)' : 'var(--color-text)'};
  border-radius:4px;
  :hover{
    color: var(--color-headingFont);
  }
`;


const AllPosts = ({ data, pageContext, location }) => {
  const posts = data.allMdx.edges
  const { currentPage, numPages } = pageContext;
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === numPages;
  const prevPage = currentPage - 1 === 1 ? "/allposts" : (currentPage - 1).toString()
  const nextPage = (currentPage + 1).toString()

  return (
    <AnotherLayout>
      <Seo
        title="All Posts"
        pathname={location.pathname}
      />
      <div>
      <h4 style={{ marginLeft: rhythm(1), color: 'var(--color-primary)' }}>All Posts</h4>
      <BlogsDiv>
        {
          posts.map(post => {
            let slug = post.node.fields.slug;
            let frontMatter = post.node.frontmatter;

            return (
              <Blog
                key={slug}>
                <Link className="nostyle" to={slug}>
                  <div style={{
                    padding: rhythm(1)
                  }}>
                    <small> <EmojiWrapper emoji="🌱" name="written on" /> {frontMatter.date}</small>
                    <h1>{frontMatter.title}</h1>
                    <p>{post.node.excerpt}</p>
                    <small>
                      <EmojiWrapper
                        emoji="🕓"
                        name="time to read"
                      /> {post.node.timeToRead} min. read</small>
                  </div>
                </Link>
              </Blog>
            );
          })
        }
      </BlogsDiv>
      </div>
      {numPages > 1 ? (
        <PaginationDiv>
          {!isFirstPage && (
            <Link style={{ padding: 0, margin: `0 ${rhythm(0.4)}` }} className="nostyle" to={prevPage} rel="prev">
              <PaginationItems>← Previous Page</PaginationItems>
            </Link>
          )}
          {Array.from({ length: numPages }, (_, i) => (

            <Link style={{ padding: 0, margin: `0 ${rhythm(0.4)}` }} className="nostyle" key={`pagination-number${i + 1}`} to={`/allposts/${i === 0 ? "" : i + 1}`}>
              <PaginationItems currentPage={i + 1 === currentPage}>{i + 1}</PaginationItems>
            </Link>
          ))}
          {!isLastPage && (
            <Link style={{ padding: 0, margin: `0 ${rhythm(0.4)}` }} className="nostyle" to={nextPage} rel="next">
              <PaginationItems>Next Page →</PaginationItems>
            </Link>
          )}
        </PaginationDiv>
      ) : null}       
    </AnotherLayout >
  )
}

export default AllPosts;

export const pageQuery = graphql`
  query blogPageQuery($skip: Int!, $limit: Int!){
    allMdx(
      sort: { fields: [frontmatter___date ], order: DESC },
      limit: $limit,
      skip: $skip    
    ) {
      edges {
        node {
          timeToRead
          excerpt(pruneLength: 60)
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
  `

